var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{ref:"singleSelect",attrs:{"items":_vm.list,"label":_vm.label,"hide-details":""},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }